import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { autoHeightSheetOptions } from 'src/app/utils/auto-height-sheet';

export type VentaRapidaInfoVariant = 'help' | 'no-product';

const HELP_STEP_KEYS: readonly string[] = [
  'venta-rapida.info.help.steps.1',
  'venta-rapida.info.help.steps.2',
  'venta-rapida.info.help.steps.3',
];

@Component({
  selector: 'app-venta-rapida-info-modal',
  templateUrl: './venta-rapida-info-modal.component.html',
  styleUrls: ['./venta-rapida-info-modal.component.scss'],
  standalone: false
})
export class VentaRapidaInfoModalComponent {
  @Input() variant: VentaRapidaInfoVariant = 'help';

  readonly helpStepKeys = HELP_STEP_KEYS;

  constructor(private readonly modalCtrl: ModalController) {}

  static async open(modalCtrl: ModalController, variant: VentaRapidaInfoVariant): Promise<void> {
    const modal = await modalCtrl.create({
      component: VentaRapidaInfoModalComponent,
      componentProps: { variant },
      ...autoHeightSheetOptions(),
    });
    await modal.present();
  }

  get isNoProduct(): boolean {
    return this.variant === 'no-product';
  }

  /** Sin id, `dismiss` cierra el modal de arriba: el help si está abierto, si no este. */
  close(): void {
    this.modalCtrl.dismiss();
  }

  /** Abre la explicación encima de este sheet, sin cerrarlo (spec: "lo complementa, no lo reemplaza"). */
  async openHelp(): Promise<void> {
    await VentaRapidaInfoModalComponent.open(this.modalCtrl, 'help');
  }
}
